var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.info.name)+" ")]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.$pub.imageUrl+_vm.info.image,"alt":""}}),_c('div',[_c('span',[_vm._v("分辨率："+_vm._s(_vm.info.ratio))]),_c('i',{staticClass:"el-icon-download",on:{"click":_vm.download}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }